"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ColumnRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/**
 *
 * A component that is renderered for each row of data.
 *
 * @typedef Column
 * @type ReactElement
 *
 * @prop {Object} columnProps
 * A mixture of default props and those passed through `Column.props.columnProps`. This object should
 * be able to be spread onto the svg element eg. `<rect {...props.columnProps}/>`.
 *
 * @prop {number} columnProps.x
 * The pixel x coordinate of the column rectangle's top left corner
 *
 * @prop {number} columnProps.y
 * The pixel y coordinate of the column rectangle's top left corner
 *
 * @prop {number} columnProps.width
 * The width of the column rectangle
 *
 * @prop {number} columnProps.height
 * The height of the column rectangle
 *
 * @prop {Object} dimensions
 * An object containing the `x` and `y` dimension values for this chart. As well as any other
 * dimensions defined when setting up the chart.
 *
 * @prop {number} index
 * The index for this row
 *
 * @prop {ChartData} data
 * The `ChartData` object that is being used to for this chart.
 *
 *
 * @prop {Object[]} scaledData
 * The full array of pre scaled data.
 *
 */
function DefaultColumn(props) {
  return _react.default.createElement("rect", (0, _extends2.default)({
    fill: "black"
  }, props.columnProps));
}

var isNumber = function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}; // @TODO switch to flow types


var ColumnRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ColumnRenderable, _React$PureComponent);

  function ColumnRenderable() {
    (0, _classCallCheck2.default)(this, ColumnRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ColumnRenderable).apply(this, arguments));
  }

  (0, _createClass2.default)(ColumnRenderable, [{
    key: "buildColumn",
    value: function buildColumn(row, index, orientation, bandwidth) {
      if (!isNumber(row.x) || !isNumber(row.y)) return null;
      var Column = this.props.column;
      var x, y, width, height;

      if (orientation === 'vertical') {
        x = row.x - bandwidth / 2;
        y = row.y;
        width = bandwidth;
        height = this.props.height - row.y;
      } else {
        x = 0;
        y = row.y - bandwidth / 2;
        width = row.x;
        height = bandwidth;
      }

      return _react.default.createElement(Column, {
        key: index,
        columnProps: (0, _objectSpread2.default)({
          x: x,
          y: y,
          width: width,
          height: height
        }, this.props.columnProps),
        dimensions: row,
        index: index,
        data: this.props.data,
        scaledData: this.props.scaledData
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          xScale = _this$props.xScale,
          yScale = _this$props.yScale;
      var orientation = this.props.orientation || xScale.bandwidth ? 'vertical' : yScale.bandwidth ? 'horizontal' // eslint-disable-next-line no-console
      : console.error('Column chart must have at least one band scale');
      if (!orientation) return null;
      var bandwidth = orientation === 'vertical' ? xScale.bandwidth() : yScale.bandwidth();
      return _react.default.createElement("g", null, this.props.scaledData.map(function (row, index) {
        return _this.buildColumn(row, index, orientation, bandwidth);
      }));
    }
  }]);
  return ColumnRenderable;
}(_react.default.PureComponent);

exports.ColumnRenderable = ColumnRenderable;
(0, _defineProperty2.default)(ColumnRenderable, "propTypes", {
  height: _propTypes.default.number.isRequired,
  width: _propTypes.default.number,
  data: _propTypes.default.object,
  scaledData: _propTypes.default.arrayOf(_propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number
  })).isRequired,
  xScale: _propTypes.default.func.isRequired,
  yScale: _propTypes.default.func.isRequired,
  columnProps: _propTypes.default.object,
  column: _propTypes.default.func,
  orientation: _propTypes.default.string
});
(0, _defineProperty2.default)(ColumnRenderable, "defaultProps", {
  columnProps: {},
  column: DefaultColumn
});

var Column =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Column, _React$Component);

  function Column() {
    (0, _classCallCheck2.default)(this, Column);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Column).apply(this, arguments));
  }

  (0, _createClass2.default)(Column, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(ColumnRenderable, this.props);
    }
  }]);
  return Column;
}(_react.default.Component);

exports.default = Column;
(0, _defineProperty2.default)(Column, "chartType", 'canvas');
(0, _defineProperty2.default)(Column, "propTypes", {
  columnProps: _propTypes.default.object,
  column: _propTypes.default.func,
  orientation: _propTypes.default.string
});